import { array, option } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import { TPlainUser } from "../../../../../domain/codecs/User";

export type TJobAssigneeDisplay = {
    isAssigned: boolean;
    initials: string;
    title: string;
};

export const getJobAssigneeDisplay = (
    assignedTo: string | null,
    users: Array<TPlainUser>,
): TJobAssigneeDisplay => {
    const assignedUser = pipe(
        users,
        array.findFirst((user) => user.id === assignedTo),
        option.toNullable,
    );

    if (assignedUser !== null) {
        return {
            isAssigned: true,
            initials: `${assignedUser.first_name.charAt(0)}${assignedUser.last_name.charAt(0)}`.toUpperCase(),
            title: `${assignedUser.first_name} ${assignedUser.last_name}`.trim(),
        };
    }

    // A job CAN be owned by someone the board cannot name — the picker is scoped to
    // front-line staff by a founder decision (bf35e9fd5) and roles change afterwards. Saying
    // "Unassigned" there reads as nobody-owns-this on the queue staff work from.
    return assignedTo !== null
        ? { isAssigned: true, initials: "?", title: "Assigned to someone outside this list" }
        : { isAssigned: false, initials: "–", title: "Unassigned" }
    ;
};
